<template>
    <div class="main-form">
        <h1 class="header-title">Required RAMS signatures pending/expired</h1>
        <div>
            <p>
                This report shows all the required RAM signatures which are older than the version or required RAMs not signed. It is ordered by person.                
            </p>
        </div>
        <div class="buttons">
            <!--<button type="button" class="btn btn-secondary btn-sm" @click="download(false)">Open</button>-->
            <button type="button" class="btn btn-primary btn-sm" @click="download(true)">Download</button>
        </div>
    </div>
</template>

<script>

    export default {
        data() {
            return {
            }
        },
        async created() {
        },
        computed: {
        },
        methods: {
            download(download) {
                this.$store.dispatch('reports/getRequiredRAMsByPersonReport', { download });
            },
        }
    }
</script>

<style>
</style>
